// @flow
import { Map }     from 'immutable';
import { Reducer } from '../../Reducer';
import * as TYPES  from './types';

const DEFAULT_STATE = Map({
    language:      'en',
    configuration: {}
});

export default class InternalizationReducer extends Reducer {
    NAME = 'Internalization';
    alias = {
        [ TYPES.INTERNALIZATION_LOAD_CONFIGURATION ]: 'onLoad',
        [ TYPES.INTERNALIZATION_CHANGE_LANGUAGE ]:    'onChange'
    };

    /**
     *
     * @param state
     * @param payload
     * @return {*|Immutable.Map<any, any>|Immutable.Map<string, {}|string>}
     */
    onLoad ( state = DEFAULT_STATE, { payload } ) {
        return state.set('configuration', payload);
    }

    /**
     *
     * @param state
     * @param payload
     * @return {*|Immutable.Map<any, any>|Immutable.Map<string, {}|string>}
     */
    onChange ( state = DEFAULT_STATE, { payload } ) {
        return state.set('language', payload);
    }

    /**
     *
     * @return {*|Immutable.Map<any, any>|Immutable.Map<string, Array|{}|boolean>}
     */
    onDefault ( state = DEFAULT_STATE ) {
        return state;
    }
}
